<template>
    <section class="services_section">
        <h3 class="characteristics_title text_align_center">Услуги 3PL</h3>
        <div class="services_box_info">
            <p class="characteristics_indentation_subtext_box5 services_width_info letter-spacing-1">
                Компания ТД Шкуренко - один из крупнейших логистических
                провайдеров в Сибирском федеральном округе. Предоставляет
                комплекс логистических услуг любой сложности. Принимаем и
                разгружаем, храним в нужном Вам температурном режиме,
                комплектуем по заказам, осуществляем доставку вашим клиентам.
            </p>
        </div>
        <div class="container_services_block">
            <div class="box_services_left">
                <div class="services_block_1">
                    <div class="box_title_services">
                        <p class="number_box_services">01</p>
                        <p class="number_box_services">Решения для клиентов</p>
                    </div>
                    <div class="box_subtext_services">
                        <p class="subtext_services text_align_right">
                            · Внедрена и используется многофункциональная
                            система управления складом LEAD WMS
                        </p>
                        <p class="subtext_services text_align_right">
                            · Индивидуальный расчёт тарифов<br />
                            под потребности клиента
                        </p>
                        <p class="subtext_services text_align_right">
                            · Хранение разных групп товаров<br />
                            в подходящих условиях
                        </p>
                        <p class="subtext_services text_align_right">
                            · Интеграция с учетной системой клиента любой
                            сложности
                        </p>
                        <p class="subtext_services text_align_right">
                            · Партионный учет и отгрузка по срокам (ОСГ, FIFO,
                            FEFO и пр.)
                        </p>
                    </div>
                </div>
                <div class="services_block_2">
                    <div class="box_title_services">
                        <p class="number_box_services">02</p>
                        <p class="number_box_services">Складская обработка</p>
                    </div>
                    <div class="box_subtext_services">
                        <p class="subtext_services text_align_right">
                            · приемка по артикулам
                        </p>
                        <p class="subtext_services text_align_right">
                            · механизированная или ручная разгрузка
                        </p>
                        <p class="subtext_services text_align_right">
                            · комплектация заявок
                        </p>
                        <p class="subtext_services text_align_right">
                            · паллетизация
                        </p>
                        <p class="subtext_services text_align_right">
                            · отгрузка
                        </p>
                        <p class="subtext_services text_align_right">
                            · кросс докинг
                        </p>
                    </div>
                </div>
            </div>
            <div class="box_services_center">
                <div class="services_block_3">
                    <div class="box_title_services">
                        <p class="number_box_services">03</p>
                        <p class="number_box_services">
                            Городская и региональная доставка
                        </p>
                    </div>
                    <div class="box_subtext_services">
                        <p class="subtext_services text_align_right">
                            · Региональная доставка
                        </p>
                        <p class="subtext_services text_align_right">
                            · Доставка клиентам "24 часа"
                        </p>

                        <p class="subtext_services text_align_right">
                            · Инкассация наличных денежных средств
                        </p>

                        <p class="subtext_services text_align_right">
                            · Возможность организации<br />
                            индивидуальной доставки
                        </p>
                        <p class="subtext_services text_align_right">
                            · Возможность доставки<br />
                            с учетом временных окон клиента
                        </p>
                        <p class="subtext_services text_align_right">
                            · Маршрутизация и расчёт оптимальной<br />
                            доставки под потребность клиента
                        </p>
                    </div>
                </div>
                <div class="services_block_4">
                    <div class="box_title_services">
                        <p class="number_box_services">04</p>
                        <p class="number_box_services">
                            Ответственное хранение
                        </p>
                    </div>
                    <div class="box_subtext_services">
                        <p class="subtext_services text_align_right">
                            · Предоставление необходимой<br /> отчетности в режиме реального времени
                        </p>
                        <p class="subtext_services text_align_right">
                            · Соблюдение требований товарного соседства
                        </p>
                        <p class="subtext_services text_align_right">
                            · Товар на хранение принимается по артикулам,<br />
                            срокам годности, партиям
                        </p>
                        <p class="subtext_services text_align_right">
                            · Доступно стеллажное хранение:<br />
                            фронтальное, мезонин, полочное
                        </p>
                        <p class="subtext_services text_align_right">
                            · Возможность выбора температурного режима,<br />
                            от -25°С до +21°С
                        </p>
                    </div>
                </div>
            </div>
            <div class="box_services_right">
                <div class="box_title_services">
                    <p class="number_box_services">05</p>
                    <p class="number_box_services">
                        Дополнительные<br />
                        складские услуги
                    </p>
                </div>
                <div class="box_subtext_services">
                    <p class="subtext_services text_align_right">
                        · Приёмка/Отгрузка ЖД поставок
                    </p>
                    <p class="subtext_services text_align_right">
                        · Паллетизация
                        Предоставление гофрокороба, поддона и прочей упаковочной тары
                    </p>
                    <p class="subtext_services text_align_right">
                        · Комплекс услуг по работе с холодильным оборудованием и POS-материалами
                    </p>
                    <p class="subtext_services text_align_right">
                        · Работа с возвратами, утилизация брака по требованию клиента
                    </p>
                    <p class="subtext_services text_align_right">
                        · Взаимодействие с государственными контрольными системами
                        ЕГАИС, Меркурий, Честный знак.
                    </p>
                    <p class="subtext_services text_align_right">
                        · Оформление документов
                    </p>
                    <p class="subtext_services text_align_right">
                        · Взвешивание и измерение габаритов
                    </p>
                    <p class="subtext_services text_align_right">
                        · Инвентаризация
                    </p><p class="subtext_services text_align_right">
                        · Сортировка
                    </p>
                    <p class="subtext_services text_align_right">
                        · Пломбирование
                    </p>
                </div>
            </div>
            <!-- <img
                src="@/assets/elements/Vector_3pl.svg"
                class="vector_3pl"
            />
            <img
                src="@/assets/elements/Vector_3pl_v2.svg"
                class="vector_3pl_v2"
            /> -->
        </div>
        <!-- <img
            src="@/assets/background/Triangles_3.png"
            class="Triangles_3"
        />
        <img
            src="@/assets/background/Triangles_3_mob.png"
            class="Triangles_3_mob"
        />
        <img
            src="@/assets/background/Triangles_3_mob_v2.png"
            class="Triangles_3_mob_v2"
        /> -->
    </section>
</template>

<script>
export default {
    name: 'ServicesSection',
};
</script>

<style scoped>
.Triangles_3 {
    width: 35rem;
    height: 60rem;
    position: absolute;
    z-index: -2;
    right: 0px;
    top: -6.6rem;
}
.Triangles_3_mob,
.Triangles_3_mob_v2 {
    display: none;
}
@media (max-width: 767px) {
    .Triangles_3 {
        display: none;
    }
    .Triangles_3_mob {
        display: block;
        position: absolute;
        z-index: -2;
        width: 23.06rem;
        height: 47.81rem;
        right: 0px;
        top: -7.5rem;
    }
    .Triangles_3_mob_v2 {
        display: block;
        position: absolute;
        z-index: -2;
        width: 23.13rem;
        height: 57.88rem;
        left: 0px;
        bottom: 12rem;
    }
}
</style>
